import { integrationService } from "../services/integrationService";
import { TelemetryClient } from "./TelemetryClient";
import type { AlertClientResponse } from "./types";

export class BackendTelemetryClient extends TelemetryClient {
  async getAlerts(): Promise<AlertClientResponse[]> {
    return integrationService.listAlarms(this.integration.id);
  }
}
